import { Route } from "react-router-dom";
import { UltimateXmenBundleScreen } from "./UltimateXmenBundleScreen";

export const routes = (
  <Route path="ultimate-x-men-bundle" element={<UltimateXmenBundleScreen />} />
);
